import React from 'react';
import { Container, Wrapper } from './style';
import Logo from '../Logo';
import { NavLink } from '../Navbar/style';

const Footer = () => {
  return (
    <Container>
      <Wrapper>
        <NavLink to="/home">
          <Logo />
        </NavLink>
      </Wrapper>{' '}
      ©{new Date().getFullYear()} by Bobur Muhibullaev.
    </Container>
  );
};

export default Footer;
